export const getFixedAspectRatioImagePath = (url, slug, assetPath, aspectRatio) => {
    const imageUrl = new URL(`${slug}/${assetPath}`, url);
    // https://docs.imgix.com/apis/rendering/size/ar
    imageUrl.searchParams.append("w", window.amplify.landingImgWidth);
    imageUrl.searchParams.append("h", window.amplify.landingImgHeight);
    imageUrl.searchParams.append("fit", "crop");
    imageUrl.searchParams.append("crop", "entropy,faces");
    return imageUrl;
};
